import type { ServerListParams } from '@crm/shared';
import { createCrudThunks } from '../../store/createCrudThunks';
import { queueApi } from './queueApi';
import type { Queue, QueueCreatePayload, QueueUpdatePayload } from './queueTypes';

const thunks = createCrudThunks<Queue, QueueCreatePayload, QueueUpdatePayload, ServerListParams>(
  'queues',
  queueApi,
);

export const queueThunks = thunks;
export const {
  fetchAll: fetchQueues,
  fetchOne: fetchQueue,
  create: createQueue,
  update: updateQueue,
  remove: deleteQueue,
} = thunks;
